import { createExternalStore } from '@iheartjane/utils';
import { useEffect, useSyncExternalStore } from 'react';

// Module-level so a favorite saved after sign-in survives the card remounting when the menu revalidates.
const { notify, subscribe } = createExternalStore();
const favoriteOverrides = new Map<number, boolean>();

export const setPendingFavorite = (productId: number, isFavorite: boolean) => {
  favoriteOverrides.set(productId, isFavorite);
  notify();
};

export const clearPendingFavorites = () => {
  favoriteOverrides.clear();
  notify();
};

export const usePendingFavorite = (productId: number) =>
  useSyncExternalStore(
    subscribe,
    () => favoriteOverrides.get(productId),
    () => undefined
  );

export const useClearPendingFavoritesOnSignOut = (isSignedIn: boolean) => {
  useEffect(() => {
    if (!isSignedIn) {
      clearPendingFavorites();
    }
  }, [isSignedIn]);
};
